/**
 * Dashboard profile-completion alert.
 */
import React, { useState, useEffect } from "react";
import { Alert, Collapse } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { VText } from "form";
import { useAsterController } from "context";

/**
 * Prompts the learner to finish their profile when login history is short.
 */
const DashboardAlert = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { loginHists, loadedDashboard, user } = controller;

  const [show, setShow] = useState(false);

  useEffect(() => setShow(loginHists.total <= 3 && !user.bio && loadedDashboard ? true : false), [loginHists.total, user.bio, loadedDashboard]);

  return (
    <div className="w-10/12 mx-auto">
      <Collapse in={show}>
        <Alert onClose={() => setShow(false)} className="my-4">
          <VText>{t("Promote exchanges on the platform by filling out your profile.")}</VText>
          <Link to="/profile" className="text-decoration-none fsp-14 color-main1 no-underline ml-4">
            <Icon icon="akar-icons:plus" className="align-middle text-sm" />
            &nbsp;{t("Complete my profile")}
          </Link>
        </Alert>
      </Collapse>
    </div>
  );
};

export default DashboardAlert;
